import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateChatSession } from '../../api/sessions.api';
import { ContextDto, ContextListResponseDto } from '@inference.engine/api-client';
import { SESSIONS_QUERY_KEY_ROOT } from '@/shared/constants/query-keys.constants';
import type { UpdateChatSessionParams } from './useUpdateChatSession.types';
import { track } from '@/shared/analytics';

export const useUpdateChatSession = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ contextId, title }: UpdateChatSessionParams) =>
      updateChatSession(contextId, { title }),
    onSuccess: (_data: ContextDto, variables: UpdateChatSessionParams) => {
      track('session_renamed', { session_id: variables.contextId });
      // Optimistically update all sessions query caches
      queryClient.setQueriesData<ContextListResponseDto>(
        { queryKey: [SESSIONS_QUERY_KEY_ROOT] },
        (oldData: ContextListResponseDto | undefined) => {
          if (!oldData) return oldData;

          return {
            contexts: oldData.contexts.map((chat: ContextDto) =>
              chat.id === variables.contextId ? { ...chat, title: variables.title } : chat,
            ),
            total: oldData.total,
          };
        },
      );
    },
  });
};
